import styled from 'styled-components';

const red500 = '#ef4444';

export const TestEnvWarning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: ${red500};
  color: white;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
`;

export const Container = styled.main`
  display: flex;
  width: 100%;
  /* max-width: 1920px; */
  height: 100vh;
  margin: 0 auto;
  position: relative;

  .scrollHidden {
    scrollbar-width: none;
  }

  .scrollHidden::-webkit-scrollbar {
    display: none;
  }
`;

export const Content = styled.section`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
`;
